export const IOS_APP_STORE_URL =
  'https://apps.apple.com/us/app/remente-self-care-wellbeing/id961633456';

export const ANDROID_APP_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.remente.app';
